
import {
  CdkOverlayOrigin, Overlay, OverlayConfig, OverlayModule, OverlayRef,
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  inject,
  input,
  output,
} from '@angular/core';

import {
  LanguageService, User, Language, AuthService,
} from '@instaclause-webapp/shared-core';
import { InitialsPipe, InlineSvgComponent } from '@instaclause-webapp/shared-ui';
import { TranslocoModule } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-menu',
  imports: [
    CommonModule,
    OverlayModule,
    InlineSvgComponent,
    TranslocoModule,
    InitialsPipe,
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent implements OnInit, OnDestroy {

  @ViewChild('menuTemplate') menuTemplate!: TemplateRef<ElementRef>;
  menuClose = output<void>();
  user = input<User>();
  availableLanguages!: Language[];
  overlayRef!: OverlayRef;
  languagesLength!: number;
  languageMenuOpen = false;

  protected languageService = inject(LanguageService);
  private subscription = new Subscription();
  private authService = inject(AuthService);
  private overlay =  inject(Overlay);
  private viewContainerRef = inject(ViewContainerRef);


  ngOnInit(): void {
    this.availableLanguages = this.languageService.getAvailableLanguages();
    this.languagesLength = this.availableLanguages.length;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openMenu(origin: CdkOverlayOrigin) {
    if (this.overlayRef) {
      this.overlayRef.detach();
    }

    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(origin.elementRef)
      .withPositions([
        {
          originX: 'center',
          originY: 'bottom',
          overlayX: 'center',
          overlayY: 'top',
          offsetY: 20,
        },
      ]);

    const overlayConfig = new OverlayConfig({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });

    this.overlayRef = this.overlay.create(overlayConfig);
    const portal = new TemplatePortal(this.menuTemplate, this.viewContainerRef);
    this.overlayRef.attach(portal);

    this.subscription = this.overlayRef.backdropClick().subscribe(() => this.closeMenu());
  }

  closeMenu() {
    if (this.overlayRef) {
      this.menuClose.emit();
      this.overlayRef.detach();
    }
  }

  onChangeLanguageOpen() {
    this.languageMenuOpen = !this.languageMenuOpen;
  }

  onChangeLanguage(language: Language): void {
    this.languageService.changeLanguage(language);
  }

  async logout() {
    await this.authService.logout();
  }
}
